

















































import { computed, defineComponent } from "@vue/composition-api";
import { LivechatSubjectType, LiveChatUser } from "@scrile/api-provider/dist/api/LivechatsProvider";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import emitter from "@/lib/emitter";
import { MediaFilesController } from "@/lib/MediaFilesController";
import config from "@/config";
import { EVENTS } from "@/const";
import BaseIcon from "@/components/BaseIcon";
import SubscriberIcon from "@/components/SubscriberIcon";
import AvatarBorderAnimation from "./components/AvatarBorderAnimation";
import AvatarLiveCaption from "./components/AvatarLiveCaption";
import { SIZE } from "./const";

export default defineComponent({
  name: "BaseAvatar",
  components: { AvatarLiveCaption, AvatarBorderAnimation, BaseIcon, SubscriberIcon },
  props: {
    size: { type: [Number, String], default: 112 },
    user: { type: Object as () => UserPublicData | User },
    showBlockStatus: { type: Boolean, default: false },
    hideOnlineStatus: { type: Boolean, default: false },
    hideBroadcasting: { type: Boolean, default: false },
    showStoryCreateBtn: { type: Boolean, default: false },
    showStoryInfo: { type: Boolean, default: false },
    animate: { type: Boolean, default: false },
  },
  setup(props) {
    const src = computed(
      () =>
        (props.user && props.user.avatar && MediaFilesController.getImageThumbnail(props.user.avatar.urlPart, 224)) ||
        ""
    );
    const isBroadcasting = computed(
      () =>
        props.user && "publicLivechatUser" in props.user && !!props.user.publicLivechatUser && !props.hideBroadcasting
    );
    const broadcastingType = computed(() => {
      const type =
        isBroadcasting.value &&
        props.user &&
        "publicLivechatUser" in props.user &&
        (props.user.publicLivechatUser as LiveChatUser).chat?.subject.subjectType;
      if (type === LivechatSubjectType.COLLAB_LIVE) return "collab";
      return "public";
    });
    const online = computed(
      () =>
        config.featureUserOnlineStatus &&
        props.user &&
        "onlineStatus" in props.user &&
        props.user.onlineStatus &&
        props.user.onlineStatus.isOnline &&
        !props.hideOnlineStatus &&
        !isBroadcasting.value
    );
    const hasStories = computed(
      () =>
        config.featureStories &&
        props.showStoryInfo &&
        props.user &&
        "hasStories" in props.user &&
        props.user.hasStories
    );
    const hasNewStories = computed(
      () =>
        config.featureStories &&
        props.showStoryInfo &&
        props.user &&
        "firstNotViewedStoryId" in props.user &&
        !!props.user.firstNotViewedStoryId
    );
    const sizeDimension = computed(() => (typeof props.size === "string" ? props.size : `${props.size}px`));
    const sizeNumber = computed(() => parseInt(sizeDimension.value));
    const elementSize = computed<SIZE>(() =>
      sizeNumber.value >= 112
        ? SIZE.BIG
        : sizeNumber.value >= 72
        ? SIZE.MEDIUM
        : sizeNumber.value >= 56
        ? SIZE.SMALL
        : SIZE.X_SMALL
    );
    const borderWidth = computed(() =>
      elementSize.value === SIZE.BIG ? 4 : elementSize.value === SIZE.MEDIUM ? 3 : 2
    );

    const subscriberCost = computed(() =>
      !!(props.user as UserPublicData)?.subscriptionToMe ? (props.user as UserPublicData).subscriptionToMe?.amount : 0
    );

    const createStory = () => emitter.emit(EVENTS.SHOW_CREATE_POST, { userId: props.user?.id, type: "story" });

    return {
      src,
      online,
      isBroadcasting,
      broadcastingType,
      hasStories,
      hasNewStories,
      sizeDimension,
      sizeNumber,
      borderWidth,
      elementSize,
      createStory,
      subscriberCost,
      SIZE,
    };
  },
});
